// Componente per sistema ExeDialog DDT2026 - Step cod_commessa, data_inizio, cod_artic
import React, { useRef, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ValoriVerificati } from './ValoriVerificati';
import { WebCam } from './WebCam';

export function CodCommessa(props) {
    const { onFinish, verificaData } = props;
    const tableRef = useRef();

    const opzioni = verificaData?.opzioni_selezione || [];

    useEffect(() => {
        // Focus sulla tabella se possibile
    }, [verificaData]);

    // Seleziona riga dalla tabella
    const handleRowSelect = (e) => {
        const row = e.data;
        onFinish({
            cod_commessa: row.cod_commessa,
            data_inizio: row.data_inizio,
            cod_artic: row.cod_artic,
            descrizion: row.descrizion
        });
    };

    return (
        <div className="card-body">
            <h5 className="card-title">Commessa</h5>
            <p className="text-muted">Seleziona una commessa dalla tabella.</p>
            
            {opzioni.length === 0 ? (
                <div className="alert alert-warning">
                    Nessuna commessa disponibile per questo cliente.
                </div>
            ) : (
                <div className="card mb-3">
                <DataTable 
                    ref={tableRef}
                    value={opzioni} 
                    selectionMode="single" 
                    onRowSelect={handleRowSelect}
                    size="small"
                    scrollable
                    scrollHeight="800px"
                    stripedRows
                    header="Commesse Prodotti"
                    filterDisplay="row"
                >
                    <Column field="cod_commessa" header="Commessa" sortable />
                    <Column field="data_inizio" header="valida dal" body={(row) => row.data_inizio ? new Date(row.data_inizio).toLocaleDateString() : ''} sortable />
                    <Column field="descrizion" header="Articolo" sortable filter showFilterMenu={false} />
                    <Column field="unita" header="Unita" sortable />
                    <Column field="note" header="Note" sortable />
                </DataTable>
                </div>
            )}
            
            <WebCam verificaData={verificaData} target="cassone" />
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

CodCommessa.displayName = 'cod_commessa';
